import jQuery from "jquery";
(function($) {
	'use strict';

	// Check if spine calculator exists on the page
	if (!$('.spine-calculator').length) {
		return;
	}

	// Spine calculator constraints
	const SPINE_CONFIG = {
		cover: {
			min: 2,
			max: 500,
			step: 2
		},
		text: {
			min: 2,
			max: 2000,
			step: 2
		},
		glueAllowance: 0.5 // Fixed value in mm
	};

	// Debounce function
	function debounce(func, wait) {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}

	// Initialize calculator for each instance
	$('.spine-calculator form').each(function() {
		const $form = $(this);
		const formId = $form.attr('id');
		
		// Cache form input selectors
		const $coverPages = $form.find(`#${formId}-cover-pages`);
		const $coverStock = $form.find(`#${formId}-cover-stock`);
		const $coverThickness = $form.find(`#${formId}-cover-thickness`);
		
		const $textPages = $form.find(`#${formId}-text-pages`);
		const $textStock = $form.find(`#${formId}-text-stock`);
		const $textThickness = $form.find(`#${formId}-text-thickness`);
		
		const $glueAllowance = $form.find(`#${formId}-glue-allowance`);
		const $glueAllowanceDisplay = $form.find(`#${formId}-glue-allowance-display`);
		
		const $grandTotal = $form.find(`#${formId}-grand-total`);
		
		// Cache breakdown selectors
		const $coverCalc = $form.closest('.spine-calculator').find(`#${formId}-cover-calc`);
		const $coverResult = $form.closest('.spine-calculator').find(`#${formId}-cover-result`);
		const $textCalc = $form.closest('.spine-calculator').find(`#${formId}-text-calc`);
		const $textResult = $form.closest('.spine-calculator').find(`#${formId}-text-result`);
		const $glueResult = $form.closest('.spine-calculator').find(`#${formId}-glue-result`);
		const $totalResult = $form.closest('.spine-calculator').find(`#${formId}-total-result`);
		const hasBreakdown = $coverCalc.length > 0;

		// Calculate thickness: (pages / 2) * stock thickness in mm
		function calculateThickness(pages, stockThicknessMm) {
			if (!pages || !stockThicknessMm) {
				return 0;
			}
			return (pages / 2) * stockThicknessMm;
		}

		
		function sanitizeNumber($input) {
			const minAttr  = $input.attr('min');
			const maxAttr  = $input.attr('max');
			const stepAttr = $input.attr('step');

			const min  = minAttr !== undefined ? parseFloat(minAttr) : -Infinity;
			const max  = maxAttr !== undefined ? parseFloat(maxAttr) :  Infinity;
			const step = stepAttr !== undefined ? parseFloat(stepAttr) : 1;

			let v = parseFloat($input.val());

			// If empty or non-numeric (user still typing), do nothing
			if (!Number.isFinite(v)) return;

			// 1) Clamp to min/max
			v = Math.min(Math.max(v, min), max);
			
			/* Optional Implementation
			// If implemented, set binding to "on change blur"
			// 2) Snap to step grid relative to min
			//    This ensures values are: min + n*step (n integer)
			v = min + Math.round((v - min) / step) * step;

			// 3) Re-clamp in case rounding pushed out of bounds
			v = Math.min(Math.max(v, min), max);
			*/

			$input.val(v);
		}

		// Update all calculations
		function updateCalculations() {
			// Get input values
			const coverPages = parseFloat($coverPages.val()) || 0;
			const coverStockThicknessMm = parseFloat($coverStock.val()) || 0;
			const textPages = parseFloat($textPages.val()) || 0;
			const textStockThicknessMm = parseFloat($textStock.val()) || 0;
			const glueAllowance = SPINE_CONFIG.glueAllowance;

			// Calculate thicknesses
			const coverThickness = calculateThickness(coverPages, coverStockThicknessMm);
			const textThickness = calculateThickness(textPages, textStockThicknessMm);
			const grandTotal = coverThickness + textThickness + glueAllowance;
			
			// Update form displays
			$coverThickness.val(coverThickness.toFixed(3));
			$textThickness.val(textThickness.toFixed(3));
			$glueAllowanceDisplay.val(glueAllowance.toFixed(3));
			$grandTotal.text(`${grandTotal.toFixed(3)} mm`);
			
			// Update breakdown if it exists
			if (hasBreakdown) {
				$coverCalc.text(`${coverPages} pages ÷ 2 × ${coverStockThicknessMm === 0 ? 'No stock selected' : coverStockThicknessMm.toFixed(3) + 'mm'}`);
				$coverResult.text(`${coverThickness.toFixed(3)}mm`);
				
				$textCalc.text(`${textPages} pages ÷ 2 × ${textStockThicknessMm === 0 ? 'No stock selected' : textStockThicknessMm.toFixed(3) + 'mm'}`);
				$textResult.text(`${textThickness.toFixed(3)}mm`);
				
				$glueResult.text(`${glueAllowance.toFixed(3)}mm`);
				$totalResult.text(`${grandTotal.toFixed(3)}mm`);
			}
		}

		// Debounced update
		const debouncedUpdate = debounce(updateCalculations, 300);

		// Bind events
		$coverPages.on('input change', function () {
			sanitizeNumber($(this));
			debouncedUpdate();
		});
		$coverStock.on('change', debouncedUpdate);		
		$textPages.on('input change', function () {
			sanitizeNumber($(this));
			debouncedUpdate();
		});
		$textStock.on('change', debouncedUpdate);

		// Initial calculation
		updateCalculations();
	});

})(jQuery);